import React, { useState, useEffect } from 'react';
import millify from 'millify';
import { useGetCryptosQuery } from '../servises/cryptoapi';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input } from 'antd';

const Cryptocerrencies = ({ simplified }) => {
  const count = simplified ? 10 : 100;
  const [searchTerm, setSearchTerm] = useState('');
  const { data: cryptosList, isFetching } = useGetCryptosQuery(count);
  const [cryptos, setCryptos] = useState([]);
  useEffect(() => {
    // setCryptos(cryptosList?.data?.coins);
    const filteredData = cryptosList?.data?.coins.filter((coin) =>
      coin.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setCryptos(filteredData);
  }, [cryptosList, searchTerm]);
  if (isFetching) return 'Loading ....';
  return (
    <>
      {!simplified && (
        <div className='search-crypto'>
          <Input
            placeholder='Search cryptocurrency'
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}
      <Row gutter={[32, 32]} className='crypto-card-container'>
        {cryptos?.map((currency) => {
          console.log(currency, 'i');
          return (
            <Col
              xs={24}
              sm={12}
              lg={6}
              className='crypto-card'
              key={currency.rank}
            >
              <Link to={`/crypto/${currency.rank}`}>
                <Card
                  title={`${currency.rank}. ${currency.name}`}
                  extra={
                    <img
                      className='crypto-image'
                      src={currency.iconUrl}
                      alt='iconUrl'
                    />
                  }
                  hoverable
                >
                  <p>Price: {millify(currency.price)}</p>
                  <p>Market Cap: {millify(currency.marketCap)}</p>
                  <p>Daily Change: {millify(currency.change)}</p>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default Cryptocerrencies;
